import React from "react";
import { useSearchParams } from "react-router-dom";

import { Helmet } from 'react-helmet';

import QuoteForm from "../components/quoteForm/QuoteForm";
import { CheckIcon, PhoneIcon } from "../components/articlesList/BlogIcons";
import translations from "../translations/quote-form";
import homeTranslations from "../translations/home";
import headerTranslations from "../components/header/header-translations";

const Quote = (props) => {

  let [searchParams] = useSearchParams()
    , service = searchParams.get("service")
  ;

  let urlPath = props.lang === 'fr' ? '' : '/' + props.lang;
  const t = translations[props.lang];
  const home = homeTranslations[props.lang];

  return (
    <div className="quote">
      <Helmet>
        <title>{t.meta.title}</title>
        <meta name="description" content={t.meta.description}/>
        <link rel="canonical" href={"https://www.davoyage.com" + urlPath + "/devis-reservation-vtc/"} />
      </Helmet>
      <div className="quote-page">
        <div className="quote-intro">
          <span className="eyebrow">{t.eyebrow}</span>
          <h1>{t.title}</h1>
          <p className="lead">{t.lead}</p>
          <ul className="quote-reassurance">
            {t.reassurance.map((item) => <li key={item}><CheckIcon />{item}</li>)}
          </ul>
        </div>
        <div className="quote-layout">
          <div className="quote-main">
            <QuoteForm lang={props.lang} vehicule={service}/>
          </div>
          <aside className="quote-aside">
            <div className="quote-aside-card">
              <h2>{t.stepsTitle}</h2>
              <ol className="quote-steps">
                {t.steps.map((step) => (
                  <li key={step.title}>
                    <strong>{step.title}</strong>
                    <span>{step.text}</span>
                  </li>
                ))}
              </ol>
            </div>
            <ul className="quote-trust">
              {home.trust.map((item) => (
                <li key={item.label}><b>{item.label}</b>{item.sub ? <> · {item.sub}</> : null}</li>
              ))}
            </ul>
            <div className="quote-contact">
              <strong>{t.contactTitle}</strong>
              <p>{t.contactText}</p>
              <a href="tel:+33660265336"><PhoneIcon />{headerTranslations[props.lang].phone}</a>
              <a href={home.hero.whatsappLink} target="_blank" rel="noreferrer">WhatsApp</a>
              <a href="mailto:contact@davoyage.com">contact@davoyage.com</a>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default Quote;
